const Alert = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g>
      <path
        d="M12.8515 4C12.4731 3.33333 11.5269 3.33333 11.1485 4L2.6332 19C2.25474 19.6667 2.72781 20.5 3.48473 20.5H20.5153C21.2722 20.5 21.7453 19.6667 21.3668 19L12.8515 4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line"
        d="M12 9V14"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="17.25" r="0.75" fill="currentColor" />
    </g>
  </svg>
);

export default Alert;
